import styled from 'styled-components'

export const TooltipWrapper = styled.div``

export const TooltipText = styled.h1`
  font-size: 1.4rem;
  padding: 0.6rem 0;
`
